<template>
    <div v-if="product" class="card">
        <div class="card-img" :style="{height: cardImgHeight}">
            <img :src="`/images/${ likedCars.find(e => e.mkt_brand_new_vehicle_id == product.id) ? 'liked-hearth.png' : 'disliked-hearth.png'}`" alt=""
            class="wish-hearth" title="Guarda tus autos favoritos para comparar facilmente más tarde"
            @click="toggleLike($event, product.id)">
            <a
                :href="getDetailUri(product)"
                :class="product.status === 'Vendido' ? 'back-sold' : ''"
            >
                <img :alt="getTitle(product)" :src="getCoverImage(product)" />
            </a>
            <div v-if="product.promotion_image" class="hot-deal">
                <img class="promo" :src="product.promotion_image" alt="promo-autodeal">
            </div>
        </div>
        <div class="card-content">
            <div class="card-text">
                <a
                    :href="getDetailUri(product)"
                    class="datasheet stretched-link"
                >
                    <div class="">
                        <span class="tx-16 ff-montserrat-bold">
                            {{ getTitle(product) }}
                        </span>
                    </div>
                    <p class="tx-14 tx-gray-ad ff-montserrat-medium">
                        {{ getVersion(product) }}
                    </p>

                    <div class="flex justify-content-around tx-12 mb-4">
                        <div class="tx-center">
                            <p class="ff-montserrat-medium mb-0">Año</p>
                            {{ product.year }}
                        </div>
                        <span class="bl mx-1"></span>
                        <div class="tx-center">
                            <p class="ff-montserrat-medium mb-0">Color</p>
                            {{ product.color }}
                        </div>
                        <span class="bl mx-1"></span>
                        <div class="tx-center">
                            <p class="ff-montserrat-medium mb-0">Disponibles</p>
                            {{ product.available }}
                        </div>
                    </div>
                    <div>
                        <p class="price ff-montserrat-bold">
                            ${{ formatNumber(product.price) }}* <span>MXN</span><br>
                            <small v-if="product.down_payment != '0.00'">Enganche desde: ${{ formatNumber(product.down_payment) }}* <span>MXN</span></small>
                        </p>
                    </div>

                    <div class="tx-12 tx-dark-ad ff-montserrat-medium">
                        <p>
                            {{
                                product.user.city_new.title + ", " + (product.user.state_new ? product.user.state_new.name : 'Sin estado')
                            }}
                        </p>
                    </div>

                    <hr class="m-1" />
                </a>
            </div>
            <div class="card-bottom">
                 <a  :href="getDetailUri(product)"
                    class="btn btn--dark-ad tx-14 flex w-full py-2">
                    Ver auto
                </a>
            </div>
        </div>
    </div>
</template>

<script>
import lineClamp from "vue-line-clamp";
import slugify from "slugify";

Vue.use(lineClamp, {
    // plugin options
});

export default {
    props: ["product", "isOwner", 'link-target', 'card-img-height', 'likes'],
    data: () => ({
        renderBackground: false,
        agencies: process.env.MIX_AGENCIES_ID, //.split(",")
        likedCars: []
    }),
    mounted() {
        this.renderBackground = this.$root.renderApp;
        this.likedCars = JSON.parse(localStorage.getItem('likes')) ?? []
    },
    watch: {
        "$root.renderApp": {
            handler(value) {
                let vm = this;
                vm.renderBackground = value;
            },
            deep: true
        }
    },
    methods: {
        toggleLike(event, id) {
            const $img = event.target
            const likes = JSON.parse(localStorage.getItem('likes')) ?? []
            const likesArrayWasFirstTimeCreated = (!localStorage.getItem('likes') || likes.length == 0) ? true : false;

            if(!likes.find(e => e.mkt_brand_new_vehicle_id == id)) {
                likes.push({
                    mkt_brand_new_vehicle_id: id
                })
                $img.src = '/images/liked-hearth.png'
                if(likes.length > 0) this.saveSingleLike({mkt_brand_new_vehicle_id: id})
                if(likesArrayWasFirstTimeCreated) this.$emit('showSignUpModal')
            }
            else {
                likes.splice(likes.findIndex(e => e.mkt_brand_new_vehicle_id == id), 1)
                if(likes.length > 0) this.deleteLike(id)
                $img.src = '/images/disliked-hearth.png'
            }

            localStorage.setItem('likes', JSON.stringify(likes))
        },
        async saveSingleLike(like) {
            try {
                await axios.post(`/save-new-like`, like);
            } catch (error) {
                console.error(error);
            }
        },
        async deleteLike(id) {
            try {
                await axios.delete(`/delete-new-like/${id}`);
            } catch (error) {
                console.error(error);
            }
        },
        getDetailUri(product) {
            let title = `${product?.user.brand_new?.title} ${product?.model} ${product.version} ${product.year} ${product?.user?.name} ${product?.user.city_new?.title} ${product?.user.state_new?.name} compra de autos nuevos`
            if (this.isOwner) {
                return `/nuevos/mis-anuncios/${product.id}`;
            }
            return `/nuevos/anuncio/${product.id}/${slugify(title)}`;
        },
        formatNumber(value) {
            let val = (value / 1).toFixed(0).replace(",", ".");
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        },
        averageScore(value) {
            return parseInt(value);
        },

        getCoverImage(product) {
            if (product.card_cover) {
                return product.card_cover.image;
            }
            if (product.gallery_first) {
                return product.gallery_first.image;
            }
            return '/files/products/default.jpg';
        },
        getTitle(product) {
            return `${product.user.brand_new.title} ${product.model}`;
        },
        getBrand(product) {
            return product.user.brand_new.title;
        },
        getVersion(product) {
            return product.version;
        }
    }
};
</script>

<style lang="scss" scoped>
@keyframes renderColor {
    0% {
        background-color: #f8f9fc;
    }
    25% {
        background-color: #cccccc;
    }
    50% {
        background-color: #c0c0c0;
    }
    75% {
        background-color: #cccccc;
    }
    100% {
        background-color: #f8f9fc;
    }
}
</style>

<style scoped>
.img-res {
  display: block;
  height: auto;
}
img.promo {
    width: 80px;
    height: 80px;
    margin: 20px 20px 0px 0px;
    background-repeat: no-repeat;
    background-size: 80px;
    padding: 1px;
}
img.wish-hearth {
    width: 35px;
    height: 35px;
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    z-index: 1;
}
</style>
